import { BaseHttpService } from "./BaseHttpService";

import { ITokenResults } from "./types";

export default class ClientTokenService extends BaseHttpService {
  public constructor(readonly url?: string) {
    super(url);
  }

  public getToken(): Promise<ITokenResults> {
    return this.get("v2/auth/temporary");
  }
}
